import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ApplicationFacade } from '@shared/data';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { RideSideMenuComponent } from '../ride-side-menu/ride-side-menu.component';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'moxi-account-side-menu',
  imports: [
    RouterModule,
    RideSideMenuComponent,

    TranslatePipe,

    // Ant Design
    NzLayoutModule,
    NzMenuModule,
    NzIconModule,
    NzTooltipModule
  ],
  templateUrl: './account-side-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSideMenuComponent {
  private readonly appFacade = inject(ApplicationFacade);

  isCollapsed = input.required<boolean>();
  accountId = input.required<string>();

  isAdmin = this.appFacade.isAdmin;
  isSuperAdmin = this.appFacade.isSuperAdmin;
  isOperator = this.appFacade.isOperator;
  hasDispatcherService = this.appFacade.hasDispatcherService;
  hasCeliosIntegrationService = this.appFacade.hasCeliosIntegrationService;
  isDispatcherDetailsIncomplete = this.appFacade.isDispatcherDetailsIncomplete;
  isDriverPermissionsIncomplete = this.appFacade.isDriverPermissionsIncomplete;
  hasOnlyOneAccount = this.appFacade.hasOnlyOneAccount;
  hasNoAccount = this.appFacade.hasNoAccount;
  hasOnlyOperatorService = this.appFacade.hasOnlyOperatorService;
  hasDispoliveIntegrationService =
    this.appFacade.hasDispoliveIntegrationService;

  path = computed(() => `/account/${this.accountId()}`);
}
